import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { router } from '../../router';
import type { AppHome } from './home/app-home.js';

import './header/header.js';
import './home/app-home.js';
import './footer/footer.component.js';

interface SectionNavigationEventDetail {
  sectionId: string;
}

@customElement('rftw-shell')
export class Shell extends LitElement {
  // private _lastPath = window.location.pathname;
  // private _pendingDirection: 'forward' | 'backward' = 'forward';

  static get styles() {
    return css`
      /* css */
      :host {
        display: grid;
        grid-template-rows: auto 1fr auto; /* Header, Main Router Slot, Bottom Nav */
        width: 100vw;
        height: 100vh;
        position: relative;
        overflow: hidden;
        background-color: #121212; /* <-- ADD THIS LINE */
      }
      main {
        position: relative;
        width: 100%;
        height: 100%;
        grid-row: 2;
        background-color: #121212;
        overflow-y: auto;
        overflow-x: hidden;
      }
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('popstate', this._handlePopState);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('popstate', this._handlePopState);
  }

  render() {
    return html`
      <app-header
        @section-navigation="${this._handleSectionNavigation}"
        @order-navigation="${this._handleOrderNavigation}"
      ></app-header>
      <main id="stage">${router.render()}</main>
    `;
  }

  private _handleSectionNavigation = (
    event: CustomEvent<SectionNavigationEventDetail>
  ) => {
    const home = this.renderRoot.querySelector<AppHome>('app-home');
    home?.scrollToSection(event.detail.sectionId);
  };

  private _handleOrderNavigation = () => {
    const home = this.renderRoot.querySelector<AppHome>('app-home');
    home?.openOrderPopup();
  };

  private _handlePopState = () => {
    // this._pendingDirection = 'backward';
  };

  // private _handleRouteChange = async () => {
  //   const nextPath = window.location.pathname;
  //   if (nextPath === this._lastPath) return;

  //   const direction = this._pendingDirection;
  //   this._pendingDirection = 'forward';

  //   if (!('startViewTransition' in document)) {
  //     this._lastPath = nextPath;
  //     this.requestUpdate();
  //     return;
  //   }

  //   document.documentElement.setAttribute(
  //     'data-transition-direction',
  //     direction
  //   );

  //   const transition = (document as any).startViewTransition(() => {
  //     this._lastPath = nextPath;
  //     this.requestUpdate();
  //   });

  //   try {
  //     await transition.finished;
  //   } finally {
  //     document.documentElement.removeAttribute('data-transition-direction');
  //   }
  // };
}
